import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import api from '../lib/api';
import { toast } from 'sonner';
import { Baby, Loader2 } from 'lucide-react';

export function ParvulariaReembolsoPanel() {
    const [rep, setRep] = useState(null);
    const [busy, setBusy] = useState(false);

    const run = async (dryRun) => {
        if (!dryRun && !window.confirm(`¿Aplicar el reembolso de ${rep?.creditos_total ?? 0} créditos a ${rep?.usuarias_afectadas ?? 0} educadoras? Esta acción se registra y no se repite para los mismos borradores.`)) return;
        setBusy(true);
        try {
            const { data } = await api.post(`/admin/parvularia/reembolso-evaluaciones-fallidas?dry_run=${dryRun}`);
            setRep(data);
            toast.success(dryRun ? 'Revisión completada (sin cambios)' : 'Reembolso aplicado');
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Error al revisar');
        } finally { setBusy(false); }
    };

    return (
        <Card data-testid="parvularia-reembolso-panel">
            <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg"><Baby className="h-5 w-5 text-pink-600" /> Parvularia · Evaluaciones sin rúbrica (reembolso)</CardTitle>
                <CardDescription>Detecta análisis anteriores que terminaron «Sin evaluar» por no activarse la rúbrica oficial pv-* y devuelve esos créditos. No modifica ni borra las evaluaciones.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-3">
                <div className="flex flex-wrap gap-2">
                    <Button size="sm" variant="outline" onClick={() => run(true)} disabled={busy} data-testid="pv-reembolso-dryrun-btn">
                        {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Revisar afectadas (sin cambios)
                    </Button>
                    <Button size="sm" onClick={() => run(false)} disabled={busy || !rep || rep.creditos_total === 0} className="bg-pink-700 hover:bg-pink-800" data-testid="pv-reembolso-apply-btn">
                        Aplicar reembolso
                    </Button>
                </div>
                {rep && (
                    <div className="text-xs text-slate-700" data-testid="pv-reembolso-report">
                        <p><strong>{rep.dry_run ? 'Revisión' : 'Aplicado'}:</strong> {rep.borradores_afectados} borradores · {rep.usuarias_afectadas} educadoras · {rep.creditos_total} créditos{rep.dry_run ? ' a reembolsar' : ' reembolsados'}.</p>
                        {rep.detalle.length > 0 && (
                            <ul className="mt-2 space-y-1">
                                {rep.detalle.map((r) => (
                                    <li key={r.email} className="flex flex-wrap justify-between gap-2 border-t border-slate-100 pt-1">
                                        <span>{r.nombre || '—'} · {r.email}</span>
                                        <span className="font-mono">{r.evaluaciones_fallidas} fallidas · {r.plan_activo ? 'plan activo (sin reembolso)' : `+${r.creditos_a_reembolsar} créditos`}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}

export default ParvulariaReembolsoPanel;
